"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _home = require("@/api/home/home.js");
var _booking = require("@/api/bookSpace/booking");
var _index = _interopRequireDefault(require("@/components/NavBarTop/index.vue"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'register',
  components: {
    navBar: _index.default
  },
  data: function data() {
    return {
      passwordVisible: false,
      passwordConfirmVisible: false,
      dialogVisible: false,
      checked: true,
      termNo: '',
      termContent: '',
      form: {
        accountNo: '',
        accountName: '',
        password: '',
        passwordConfirm: '',
        activateEmail: ''
      },
      rules: {
        accountNo: [{
          required: true,
          trigger: 'blur',
          validator: this.validateAccountName
        }],
        accountName: [{
          required: true,
          message: this.$t('home.messageFour'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePassword
        }, {
          min: 6,
          max: 30,
          message: this.$t('home.passWordError'),
          trigger: 'blur'
        }],
        account: [{
          required: true,
          message: this.$t('home.messageFour'),
          trigger: 'blur'
        }],
        passwordConfirm: [{
          required: true,
          validator: this.comparePassword,
          trigger: 'blur'
        }],
        activateEmail: [{
          required: true,
          message: this.$t('home.messageSix'),
          trigger: 'blur'
        }, {
          required: true,
          type: 'email',
          message: this.$t('home.messageThree'),
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  mounted: function mounted() {
    this.getLatestRegisterTerms();
  },
  methods: {
    handleClickIcon: function handleClickIcon() {
      this.passwordVisible = !this.passwordVisible;
    },
    handleClickIconConfirm: function handleClickIconConfirm() {
      this.passwordConfirmVisible = !this.passwordConfirmVisible;
    },
    validateAccountName: function validateAccountName(rule, value, callback) {
      var usernamePattern = /^[A-Z][A-Z0-9]{4,19}$/;
      // 必须出现数字
      var usernamePatternNum = /[0-9]+/;
      if (!value || value.length === 0) {
        callback(new Error(this.$t('home.messAccountNo')));
      } else if (!usernamePattern.test(value) || !usernamePatternNum.test(value)) {
        callback(new Error(this.$t('home.messagePassAccount')));
      } else {
        callback();
      }
    },
    validatePassword: function validatePassword(rule, value, callback) {
      var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#￥%&])[A-Za-z\d!@#￥%&]{8,30}$/;
      if (!value || value.length === 0) {
        callback(new Error(this.$t('login.passwordRequire')));
      }
      if (!passwordPattern.test(value)) {
        callback(new Error(this.$t('home.messagePass')));
      } else {
        callback();
      }
    },
    comparePassword: function comparePassword(rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('home.messageOne')));
      } else if (value !== this.form.password) {
        callback(new Error(this.$t('home.messageTwo')));
      } else {
        callback();
      }
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    getLatestRegisterTerms: function getLatestRegisterTerms() {
      var _this = this;
      (0, _booking.getLatestRegisterTerms)().then(function (res) {
        if (res.success) {
          var data = _this.language === 'en' ? res.data.termContentEn : res.data.termContent;
          _this.termContent = data.replace(/\r?\n/g, '<br>');
          _this.termNo = res.data.termNo;
        }
      });
    },
    handleRegister: function handleRegister() {
      var _this2 = this;
      if (!this.checked) {
        this.$message({
          message: this.$t('home.messAgreeRegisterText'),
          type: 'error'
        });
        return;
      }
      if (!this.termNo) {
        this.$message({
          message: '注册条款为空，请联系系统管理员',
          type: 'error'
        });
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var form = Object.assign({}, _this2.form);
          form.termNo = _this2.termNo;
          form.password = btoa(form.password);
          form.passwordConfirm = btoa(form.passwordConfirm);
          _this2.loading = (0, _utils.load)();
          (0, _home.hanleRegister)(form).then(function (res) {
            if (res.success) {
              _this2.$message({
                message: _this2.$t('home.messRegisterSuccess'),
                type: 'success'
              });
              _this2.$router.push('/');
            } else {
              _this2.$message({
                message: res.errorMessages[0],
                type: 'error'
              });
            }
          }).catch(function () {
            _this2.$message({
              message: _this2.$t('home.messRegisterFail'),
              type: 'error'
            });
          }).finally(function () {
            _this2.loading.close();
          });
        }
      });
    }
  }
};